import React, { FC } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { isDateFromLastDays } from 'utils';
import { XOR } from 'types';

import './NewTag.styles.scss';

type NewTagProps = {
  className?: string;
  variant?: 'green' | 'orange';
} & XOR<{ isNew: boolean }, { time: Date; daysAgo?: number }>;

const NewTag: FC<NewTagProps> = (props) => {
  const {
    children,
    className,
    isNew,
    time,
    daysAgo = 1,
    variant = 'orange',
  } = props;

  const classes = classNames('new-tag', variant, className);

  const { t } = useTranslation();

  if (!isNew && !isDateFromLastDays(time, daysAgo)) return null;

  return <span className={classes}>{children || t('new')}</span>;
};

export default NewTag;
